var map = {
	"./i18n/en.json": [
		42258,
		"libs_shared_ui_services_src_i18n_en_json"
	],
	"./i18n/nl.json": [
		59651,
		"libs_shared_ui_services_src_i18n_nl_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 29626;
module.exports = webpackAsyncContext;